import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import TopLeftUserName from "../components/TopLeftUserName";
import { ApplicationLookup } from "../models/Enums";
import {
  CheckIfPhoneIsMute,
  GetOSId,
  unMuteAndIncreaseVolume,
} from "../utils/mobile-bridge";
import { currentAssessmentState, networkConnectionStatus } from "../data/atoms";
import { TestType } from "../models/Enums";

interface Props {
  assessmentType: any;
}

const GaitAssessmentInfo: React.FC<Props> = ({ assessmentType }) => {
  const [isVolumeOk, setIsVolumeOk] = useState(false);
  const [isAngleCorrect, setIsAngleCorrect] = useState(true);
  const [currentAssessment] = useRecoilState(currentAssessmentState);
  const [gait_TextEnable, setgait_TextEnable] = useState(false);
  const [fiveX_TextEnable, setfiveX_TextEnable] = useState(false);
  const [header_Text, setHeader_Text] = useState("");
  const [subHeader_Text, setSubHeader_Text] = useState("");
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );

  let Window = window as any;
  Window["AssessmentInfoReference"] = {
    component: this,
    UpdateDeviceVolumeStatus: UpdateDeviceVolumeStatus,
    UpdateDeviceAngleStatus: UpdateDeviceAngleStatus,
  };

  function UpdateDeviceVolumeStatus(status: boolean) {
    debugger;
    setIsVolumeOk(status);
    // console.log("type of volume status updated with: ", typeof(status));
  }

  function UpdateDeviceAngleStatus(status: boolean) {
    setIsAngleCorrect(status);
  }

  function selectAssessment() {
    if (
      currentAssessment.assessmentType === TestType.gait ||
      assessmentType?.assessmentType === "gait"
    ) {
      setgait_TextEnable(true);
      setfiveX_TextEnable(false);
      setHeader_Text("Gait Analysis");
      setSubHeader_Text("Gait Analysis Setup Instructions");
    } else if (
      currentAssessment.assessmentType === TestType.five_x_sit_stand ||
      assessmentType?.assessmentType === "5xsts"
    ) {
      setfiveX_TextEnable(true);
      setgait_TextEnable(false);
      setHeader_Text("5 Times Sit-to-Stand");
      setSubHeader_Text("5XSTS Setup Instructions");
    } else {
      setgait_TextEnable(true);
      setfiveX_TextEnable(false);
      setHeader_Text("Gait Analysis");
      setSubHeader_Text("Gait Analysis Setup Instructions");
    }
  }

  useEffect(() => {}, [isAngleCorrect]);

  let location =
    window.location.href == window.location.origin + "/gait-assessment-info"
      ? true
      : false;

  useEffect(() => {
    // const sound = CheckIfPhoneIsMute()
    // console.log('mute or not ', sound)
    setIsVolumeOk(unMuteAndIncreaseVolume());
    selectAssessment();
  }, [location]);

  //   // native calls.
  const redirectToNextPage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    history.push("/phone-height-requirement");
  };

  let history = useHistory();
  // console.log("isVolumeOk", isVolumeOk)
  // console.log("device isAngleCorrect", isAngleCorrect)
  return (
    <IonPage placeholder={undefined}>
      <TopLeftUserName headerText={"Assessment Selection"}></TopLeftUserName>
      {gait_TextEnable && (
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container gait-assessment-info-page-main-wrap"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                {currentAssessment?.assessmentType === TestType.gait ||
                assessmentType?.assessmentType === "gait" ? (
                  <div className="gait-assessment-info-page-inner-wrap">
                    <div className="main-heading assessment-selection-heading">
                      <h1>{header_Text}</h1>
                      <p className="assessment-new-text">{subHeader_Text}</p>
                    </div>
                    <h6 className="gait-info-label">Required:</h6>
                    <ul className="gait-list">
                      <li>8.5”x11” sheet of paper</li>
                      <li>Phone Stand</li>
                      <li>Side Table</li>
                      <li>15 feet of space</li>
                    </ul>{" "}
                    <h6 className="gait-info-label instruction">
                      Instruction:
                    </h6>
                    <ol type="1">
                      <li>Paper placement to calibrate phone</li>
                      <li> Ensure patient is behind start line</li>
                      <li>At start line, raise arm for 3 sec. to start</li>
                      <li>Walk safely but briskly towards the sensor</li>
                      <li>Assessment will auto stop at finish line</li>
                    </ol>
                  </div>
                ) : (
                  <div className="gait-assessment-info-page-inner-wrap">
                    <div className="main-heading assessment-selection-heading">
                      <h1>{header_Text}</h1>
                      <p className="assessment-new-text">{subHeader_Text}</p>
                    </div>
                    <h6 className="gait-info-label">Required:</h6>
                    <ul className="gait-list">
                      <li>Standard chair</li>
                      <li>Phone Stand</li>
                      <li>Side Table</li>
                      <li>10 feet of space</li>
                    </ul>{" "}
                    <h6 className="gait-info-label instruction">
                      Instruction:
                    </h6>
                    <ol type="1">
                      <li>Place chair around 8 feet away from phone</li>
                      <li> Ensure patient is within boundaries</li>
                      <li>Raise arm to calibrate patient height</li>
                      <li>Begin seated and raise arm to start</li>
                      <li>Stand and sit down 5 times as fast as possible</li>
                    </ol>
                  </div>
                )}
              </IonCol>
            </IonRow>
            <p className="setup-check">Setup Check</p>
            {/* bg-grey bg-light-red bg-light-green */}
            <div
              className={
                isVolumeOk
                  ? "cardSetup-check bg-light-green"
                  : "cardSetup-check bg-light-red"
              }
            >
              <IonRow placeholder={undefined}>
                <IonCol size="3.5" placeholder={undefined}>
                  <div className="leftIcon-setup">
                    <div className="firstStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                      >
                        <path
                          d="M38 19C38 22.7578 36.8857 26.4313 34.7979 29.5558C32.7102 32.6804 29.7428 35.1156 26.271 36.5537C22.7992 37.9918 18.9789 38.368 15.2933 37.6349C11.6077 36.9018 8.22219 35.0922 5.56499 32.4351C2.90779 29.7779 1.09821 26.3924 0.365087 22.7068C-0.368039 19.0211 0.00821541 15.2009 1.44627 11.7291C2.88433 8.25726 5.31959 5.28986 8.44412 3.20211C11.5686 1.11435 15.2421 1.24984e-05 18.9999 1.05086e-10L19 5.13C16.2567 5.13001 13.5751 5.94348 11.2942 7.46754C9.0133 8.9916 7.23556 11.1578 6.18578 13.6922C5.136 16.2266 4.86133 19.0154 5.39651 21.7059C5.93169 24.3964 7.25269 26.8678 9.19244 28.8076C11.1322 30.7473 13.6036 32.0683 16.2941 32.6035C18.9846 33.1387 21.7734 32.864 24.3078 31.8142C26.8422 30.7644 29.0084 28.9867 30.5325 26.7058C32.0565 24.4248 32.87 21.7432 32.87 19H38Z"
                          fill="#11A0D6"
                        />
                        <path
                          d="M19 0C22.3436 3.98722e-08 25.628 0.882354 28.5215 2.55794C31.415 4.23353 33.815 6.64302 35.4793 9.54303C37.1435 12.443 38.013 15.7309 37.9999 19.0745C37.9867 22.4181 37.0915 25.699 35.4046 28.5859C33.7177 31.4727 31.2988 33.8633 28.3923 35.5162C25.4858 37.169 22.1946 38.0256 18.8511 37.9994C15.5075 37.9732 12.2302 37.0651 9.34991 35.3669C6.46966 33.6687 4.08857 31.2405 2.44712 28.3275L6.9164 25.8091C8.11466 27.9355 9.85285 29.7081 11.9554 30.9478C14.058 32.1875 16.4505 32.8504 18.8913 32.8696C21.332 32.8887 23.7346 32.2634 25.8564 31.0568C27.9781 29.8502 29.7439 28.1051 30.9754 25.9977C32.2068 23.8903 32.8603 21.4952 32.8699 19.0544C32.8795 16.6135 32.2447 14.2134 31.0299 12.0964C29.815 9.9794 28.0629 8.22048 25.9507 6.9973C23.8385 5.77412 21.4408 5.13 19 5.13V0Z"
                          fill="#54C8F2"
                        />
                      </svg>
                    </div>
                    <div className="secondStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="39"
                        height="35"
                        viewBox="0 0 39 35"
                        fill="none"
                      >
                        <path
                          d="M38.4494 32.1235L33.038 27.358C35.5907 24.8442 37.0597 21.2901 37.0597 17.5306C37.0597 13.6191 35.4847 9.9226 32.7393 7.45736C32.1164 6.88597 31.1948 6.98444 30.6803 7.68635C30.168 8.38826 30.2594 9.42434 30.8842 9.99957C32.9515 11.84 34.1339 14.6066 34.1339 17.5306C34.1339 20.454 32.949 23.2205 30.8845 25.1249C30.8208 25.1836 30.7871 25.2639 30.7346 25.3312L28.0326 22.9523C28.0633 22.9544 28.0918 22.9745 28.1226 22.9745C28.4483 22.9745 28.7778 22.8526 29.0485 22.6043C30.4219 21.338 31.2082 19.496 31.2082 17.5306C31.2082 15.5687 30.4213 13.7218 29.048 12.4591C28.4214 11.8877 27.4992 11.9883 26.9909 12.6923C26.4785 13.3942 26.5699 14.4303 27.1966 15.0055C27.8863 15.6406 28.2825 16.5582 28.2825 17.5306C28.2825 18.503 27.8863 19.422 27.1969 20.0561C26.7264 20.4883 26.5581 21.1798 26.72 21.7948L23.4062 18.8796V4.38265C23.4062 3.5205 22.959 2.73847 22.2579 2.38581C21.5569 2.03054 20.7334 2.17243 20.1593 2.74594L13.0991 9.79933L2.36586 0.349996C2.09766 0.114565 1.77949 0 1.46497 0C1.03099 0 0.599988 0.216256 0.312351 0.629253C-0.186732 1.34417 -0.0759199 2.37752 0.560307 2.93699L36.5896 34.6496C37.2296 35.2113 38.1482 35.0829 38.6431 34.3703C39.1991 33.719 39.0833 32.685 38.4494 32.1235ZM3.90126 14.2436V20.8176C3.90126 22.633 5.21114 24.043 6.82701 24.043H11.9373L20.1599 32.2536C20.5231 32.6781 20.9864 32.8699 21.4557 32.8699C21.7262 32.8699 22.0018 32.8061 22.2579 32.6756C22.9613 32.3221 23.4062 31.5414 23.4062 30.6786V27.2313L5.40985 11.388C4.51384 11.9496 3.90126 12.9494 3.90126 14.2436Z"
                          fill="#DB4B4B"
                        />
                      </svg>
                    </div>
                    <div className="thirdStep">
                      <div className="sound-icon-green">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="27"
                          viewBox="0 0 33 27"
                          fill="none"
                        >
                          <path
                            d="M25.029 9.03744C24.4054 8.53475 23.4876 8.62324 22.9817 9.24264C22.4718 9.86029 22.5628 10.7717 23.1864 11.2778C23.8704 11.8362 24.2647 12.6444 24.2647 13.4466C24.2647 14.3013 23.8704 15.1108 23.1843 15.6681C22.5607 16.1746 22.4697 17.0856 22.9796 17.7033C23.2659 18.0535 23.6845 18.2342 24.1055 18.2342C24.4296 18.2342 24.7576 18.1269 25.0269 17.9085C26.3939 16.8486 27.1765 15.226 27.1765 13.4466C27.1765 11.6673 26.3939 10.1473 25.029 9.03744ZM28.6991 4.586C28.0791 4.08332 27.1619 4.16993 26.6499 4.78746C26.14 5.40512 26.231 6.31651 26.8528 6.82258C28.9114 8.44029 30.0882 10.9254 30.0882 13.4466C30.0882 15.9679 28.909 18.3987 26.8544 20.1238C26.2326 20.6302 26.1416 21.5413 26.6515 22.1589C26.9396 22.5072 27.3564 22.688 27.7774 22.688C28.1034 22.688 28.4295 22.5807 28.7007 22.3604C31.4349 20.1901 33 16.939 33 13.4466C33 9.95426 31.4349 6.80569 28.6991 4.586ZM18.2713 0.169553C17.5737 -0.142952 16.7542 -0.0159837 16.1827 0.488633L7.99522 7.71648H2.91176C1.30362 7.71648 0 9.0121 0 10.6093V16.395C0 17.9922 1.30362 19.2878 2.91176 19.2878H7.99765L16.1809 26.5138C16.5425 26.8311 17.0035 27 17.4706 27C17.7398 27 18.0141 26.9438 18.2689 26.829C18.9689 26.5175 19.4118 25.8298 19.4118 25.0759V1.92721C19.4118 1.16901 18.9689 0.480188 18.2713 0.169553Z"
                            fill="#43BA73"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="6.5" placeholder={undefined}>
                  <h6 className="card-label">Sound Check</h6>
                  <div className="firstStep">
                    <p className="card-label2">Checking sound...</p>
                  </div>
                  <div className="secondStep">
                    <p className="card-label2">Turn on device volume</p>
                  </div>
                  <div className="thirdStep">
                    <p className="card-label2">Device Sound On</p>
                  </div>
                </IonCol>
                <IonCol size="2" placeholder={undefined}>
                  <div className="rightIcon-setup">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807612 9.97919 0.807612 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97918 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM-1.31134e-07 13.5L20 13.5L20 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </IonCol>
              </IonRow>
            </div>
            {/* bg-grey bg-light-red bg-light-green */}
            <div
              className={
                isAngleCorrect
                  ? "cardSetup-check bg-light-green"
                  : "cardSetup-check bg-light-red"
              }
            >
              <IonRow placeholder={undefined}>
                <IonCol size="3.5" placeholder={undefined}>
                  <div className="leftIcon-setup">
                    <div className="firstStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                      >
                        <path
                          d="M38 19C38 22.7578 36.8857 26.4313 34.7979 29.5558C32.7102 32.6804 29.7428 35.1156 26.271 36.5537C22.7992 37.9918 18.9789 38.368 15.2933 37.6349C11.6077 36.9018 8.22219 35.0922 5.56499 32.4351C2.90779 29.7779 1.09821 26.3924 0.365087 22.7068C-0.368039 19.0211 0.00821541 15.2009 1.44627 11.7291C2.88433 8.25726 5.31959 5.28986 8.44412 3.20211C11.5686 1.11435 15.2421 1.24984e-05 18.9999 1.05086e-10L19 5.13C16.2567 5.13001 13.5751 5.94348 11.2942 7.46754C9.0133 8.9916 7.23556 11.1578 6.18578 13.6922C5.136 16.2266 4.86133 19.0154 5.39651 21.7059C5.93169 24.3964 7.25269 26.8678 9.19244 28.8076C11.1322 30.7473 13.6036 32.0683 16.2941 32.6035C18.9846 33.1387 21.7734 32.864 24.3078 31.8142C26.8422 30.7644 29.0084 28.9867 30.5325 26.7058C32.0565 24.4248 32.87 21.7432 32.87 19H38Z"
                          fill="#11A0D6"
                        />
                        <path
                          d="M19 0C22.3436 3.98722e-08 25.628 0.882354 28.5215 2.55794C31.415 4.23353 33.815 6.64302 35.4793 9.54303C37.1435 12.443 38.013 15.7309 37.9999 19.0745C37.9867 22.4181 37.0915 25.699 35.4046 28.5859C33.7177 31.4727 31.2988 33.8633 28.3923 35.5162C25.4858 37.169 22.1946 38.0256 18.8511 37.9994C15.5075 37.9732 12.2302 37.0651 9.34991 35.3669C6.46966 33.6687 4.08857 31.2405 2.44712 28.3275L6.9164 25.8091C8.11466 27.9355 9.85285 29.7081 11.9554 30.9478C14.058 32.1875 16.4505 32.8504 18.8913 32.8696C21.332 32.8887 23.7346 32.2634 25.8564 31.0568C27.9781 29.8502 29.7439 28.1051 30.9754 25.9977C32.2068 23.8903 32.8603 21.4952 32.8699 19.0544C32.8795 16.6135 32.2447 14.2134 31.0299 12.0964C29.815 9.9794 28.0629 8.22048 25.9507 6.9973C23.8385 5.77412 21.4408 5.13 19 5.13V0Z"
                          fill="#54C8F2"
                        />
                      </svg>
                    </div>
                    <div className="secondStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.0"
                        width="37.000000"
                        height="74.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <rect
                          id="backgroundrect"
                          width="100%"
                          height="100%"
                          x="0"
                          y="0"
                          fill="none"
                          stroke="none"
                        ></rect>

                        <g className="currentLayer">
                          <title>Layer 1</title>
                          <g
                            transform="translate(0,74) scale(0.10000000149011612,-0.10000000149011612) "
                            fill="#DB4B4B"
                            stroke="#ffffff"
                            id="svg_1"
                          >
                            <path
                              d="M326 690 c6 -29 6 -29 -27 -20 -79 23 -148 7 -212 -49 l-36 -32 -3 26 c-5 44 -23 27 -23 -22 l0 -48 49 0 c31 0 51 5 54 13 2 7 -5 12 -17 12 -31 0 -26 15 15 46 27 21 50 29 94 32 64 5 111 -10 72 -22 -40 -13 -25 -29 21 -22 57 9 62 17 47 70 -14 52 -43 66 -34 16z"
                              id="svg_2"
                            ></path>
                            <path
                              d="M143 512 c-20 -12 -129 -440 -116 -453 6 -6 51 -21 101 -34 70 -17 95 -20 105 -11 14 11 42 104 34 113 -3 2 -10 -18 -16 -44 -19 -74 -19 -74 -122 -48 -50 13 -93 26 -96 29 -8 7 98 414 112 432 8 11 26 9 100 -9 101 -26 105 -31 85 -103 -7 -25 -10 -47 -8 -50 9 -8 36 113 28 126 -4 6 -49 22 -101 35 -52 14 -94 25 -94 25 0 0 -6 -4 -12 -8z"
                              id="svg_3"
                            ></path>
                            <path
                              d="M240 450 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5 0 -3 -5 5 -10z"
                              id="svg_4"
                            ></path>
                            <path
                              d="M290 235 c-12 -48 -20 -88 -17 -91 2 -3 14 34 26 82 12 48 20 88 18 90 -2 3 -14 -34 -27 -81z"
                              id="svg_5"
                            ></path>
                            <path
                              d="M125 70 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0 -8 -4 5 -9z"
                              id="svg_6"
                            ></path>
                          </g>
                          <path
                            fill=""
                            fillOpacity="1"
                            stroke="#DB4B4B"
                            strokeOpacity="1"
                            strokeWidth="1"
                            strokeDasharray="none"
                            strokeLinejoin="miter"
                            strokeLinecap="butt"
                            fillRule="nonzero"
                            opacity="1"
                            d="M34.90213087552786,28.269837608563222L23.79101968031847,72.18518185629551"
                            id="svg_7"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div className="thirdStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="53"
                        height="53"
                        viewBox="0 0 53 53"
                        fill="none"
                      >
                        <path
                          d="M26.5 51C40.031 51 51 40.031 51 26.5C51 12.969 40.031 2 26.5 2C12.969 2 2 12.969 2 26.5C2 40.031 12.969 51 26.5 51Z"
                          fill="white"
                          stroke="#43BA73"
                          strokeWidth="3"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M34.6667 21.0557L23.7778 31.9446L18.3333 26.5001"
                          stroke="#43BA73"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="6.5" placeholder={undefined}>
                  <div className="setup-content">
                    <h6 className="card-label">Device Setup </h6>
                    <div className="firstStep">
                      <p className="card-label2">Go to setup steps</p>
                    </div>
                    <div className="secondStep">
                      <p className="card-label2">
                        Correct Phone Angle Required
                      </p>
                    </div>
                    <div className="thirdStep">
                      <p className="card-label2">Phone Setup Complete</p>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="2" placeholder={undefined}>
                  <div className="rightIcon-setup">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807612 9.97919 0.807612 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97918 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM-1.31134e-07 13.5L20 13.5L20 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </IonCol>
              </IonRow>
            </div>
          </IonGrid>
        </IonContent>
      )}
      {fiveX_TextEnable && (
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container gait-assessment-info-page-main-wrap"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="gait-assessment-info-page-inner-wrap">
                  <div className="main-heading assessment-selection-heading">
                    <h1>{header_Text}</h1>
                    <p className="assessment-new-text">{subHeader_Text}</p>
                  </div>
                  <h6 className="gait-info-label">Required:</h6>
                  <ul className="gait-list">
                    <li>Standard chair</li>
                    <li>Phone Stand</li>
                    <li>Side Table</li>
                    <li>10 feet of space</li>
                  </ul>{" "}
                  <h6 className="gait-info-label instruction">Instruction:</h6>
                  <ol type="1">
                    <li>Place chair around 8 feet away from phone</li>
                    <li>Ensure patient is within boundaries</li>
                    <li>Raise arm to calibrate patient height</li>
                    <li>Begin seated and raise arm to start</li>
                    <li>Stand and sit down 5 times as fast as possible</li>
                  </ol>
                </div>
              </IonCol>
            </IonRow>
            <p className="setup-check">Setup Check</p>
            {/* bg-grey bg-light-red bg-light-green */}
            <div
              className={
                isVolumeOk
                  ? "cardSetup-check bg-light-green"
                  : "cardSetup-check bg-light-red"
              }
            >
              <IonRow placeholder={undefined}>
                <IonCol size="3.5" placeholder={undefined}>
                  <div className="leftIcon-setup">
                    <div className="firstStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                      >
                        <path
                          d="M38 19C38 22.7578 36.8857 26.4313 34.7979 29.5558C32.7102 32.6804 29.7428 35.1156 26.271 36.5537C22.7992 37.9918 18.9789 38.368 15.2933 37.6349C11.6077 36.9018 8.22219 35.0922 5.56499 32.4351C2.90779 29.7779 1.09821 26.3924 0.365087 22.7068C-0.368039 19.0211 0.00821541 15.2009 1.44627 11.7291C2.88433 8.25726 5.31959 5.28986 8.44412 3.20211C11.5686 1.11435 15.2421 1.24984e-05 18.9999 1.05086e-10L19 5.13C16.2567 5.13001 13.5751 5.94348 11.2942 7.46754C9.0133 8.9916 7.23556 11.1578 6.18578 13.6922C5.136 16.2266 4.86133 19.0154 5.39651 21.7059C5.93169 24.3964 7.25269 26.8678 9.19244 28.8076C11.1322 30.7473 13.6036 32.0683 16.2941 32.6035C18.9846 33.1387 21.7734 32.864 24.3078 31.8142C26.8422 30.7644 29.0084 28.9867 30.5325 26.7058C32.0565 24.4248 32.87 21.7432 32.87 19H38Z"
                          fill="#11A0D6"
                        />
                        <path
                          d="M19 0C22.3436 3.98722e-08 25.628 0.882354 28.5215 2.55794C31.415 4.23353 33.815 6.64302 35.4793 9.54303C37.1435 12.443 38.013 15.7309 37.9999 19.0745C37.9867 22.4181 37.0915 25.699 35.4046 28.5859C33.7177 31.4727 31.2988 33.8633 28.3923 35.5162C25.4858 37.169 22.1946 38.0256 18.8511 37.9994C15.5075 37.9732 12.2302 37.0651 9.34991 35.3669C6.46966 33.6687 4.08857 31.2405 2.44712 28.3275L6.9164 25.8091C8.11466 27.9355 9.85285 29.7081 11.9554 30.9478C14.058 32.1875 16.4505 32.8504 18.8913 32.8696C21.332 32.8887 23.7346 32.2634 25.8564 31.0568C27.9781 29.8502 29.7439 28.1051 30.9754 25.9977C32.2068 23.8903 32.8603 21.4952 32.8699 19.0544C32.8795 16.6135 32.2447 14.2134 31.0299 12.0964C29.815 9.9794 28.0629 8.22048 25.9507 6.9973C23.8385 5.77412 21.4408 5.13 19 5.13V0Z"
                          fill="#54C8F2"
                        />
                      </svg>
                    </div>
                    <div className="secondStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="39"
                        height="35"
                        viewBox="0 0 39 35"
                        fill="none"
                      >
                        <path
                          d="M38.4494 32.1235L33.038 27.358C35.5907 24.8442 37.0597 21.2901 37.0597 17.5306C37.0597 13.6191 35.4847 9.9226 32.7393 7.45736C32.1164 6.88597 31.1948 6.98444 30.6803 7.68635C30.168 8.38826 30.2594 9.42434 30.8842 9.99957C32.9515 11.84 34.1339 14.6066 34.1339 17.5306C34.1339 20.454 32.949 23.2205 30.8845 25.1249C30.8208 25.1836 30.7871 25.2639 30.7346 25.3312L28.0326 22.9523C28.0633 22.9544 28.0918 22.9745 28.1226 22.9745C28.4483 22.9745 28.7778 22.8526 29.0485 22.6043C30.4219 21.338 31.2082 19.496 31.2082 17.5306C31.2082 15.5687 30.4213 13.7218 29.048 12.4591C28.4214 11.8877 27.4992 11.9883 26.9909 12.6923C26.4785 13.3942 26.5699 14.4303 27.1966 15.0055C27.8863 15.6406 28.2825 16.5582 28.2825 17.5306C28.2825 18.503 27.8863 19.422 27.1969 20.0561C26.7264 20.4883 26.5581 21.1798 26.72 21.7948L23.4062 18.8796V4.38265C23.4062 3.5205 22.959 2.73847 22.2579 2.38581C21.5569 2.03054 20.7334 2.17243 20.1593 2.74594L13.0991 9.79933L2.36586 0.349996C2.09766 0.114565 1.77949 0 1.46497 0C1.03099 0 0.599988 0.216256 0.312351 0.629253C-0.186732 1.34417 -0.0759199 2.37752 0.560307 2.93699L36.5896 34.6496C37.2296 35.2113 38.1482 35.0829 38.6431 34.3703C39.1991 33.719 39.0833 32.685 38.4494 32.1235ZM3.90126 14.2436V20.8176C3.90126 22.633 5.21114 24.043 6.82701 24.043H11.9373L20.1599 32.2536C20.5231 32.6781 20.9864 32.8699 21.4557 32.8699C21.7262 32.8699 22.0018 32.8061 22.2579 32.6756C22.9613 32.3221 23.4062 31.5414 23.4062 30.6786V27.2313L5.40985 11.388C4.51384 11.9496 3.90126 12.9494 3.90126 14.2436Z"
                          fill="#DB4B4B"
                        />
                      </svg>
                    </div>
                    <div className="thirdStep">
                      <div className="sound-icon-green">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="27"
                          viewBox="0 0 33 27"
                          fill="none"
                        >
                          <path
                            d="M25.029 9.03744C24.4054 8.53475 23.4876 8.62324 22.9817 9.24264C22.4718 9.86029 22.5628 10.7717 23.1864 11.2778C23.8704 11.8362 24.2647 12.6444 24.2647 13.4466C24.2647 14.3013 23.8704 15.1108 23.1843 15.6681C22.5607 16.1746 22.4697 17.0856 22.9796 17.7033C23.2659 18.0535 23.6845 18.2342 24.1055 18.2342C24.4296 18.2342 24.7576 18.1269 25.0269 17.9085C26.3939 16.8486 27.1765 15.226 27.1765 13.4466C27.1765 11.6673 26.3939 10.1473 25.029 9.03744ZM28.6991 4.586C28.0791 4.08332 27.1619 4.16993 26.6499 4.78746C26.14 5.40512 26.231 6.31651 26.8528 6.82258C28.9114 8.44029 30.0882 10.9254 30.0882 13.4466C30.0882 15.9679 28.909 18.3987 26.8544 20.1238C26.2326 20.6302 26.1416 21.5413 26.6515 22.1589C26.9396 22.5072 27.3564 22.688 27.7774 22.688C28.1034 22.688 28.4295 22.5807 28.7007 22.3604C31.4349 20.1901 33 16.939 33 13.4466C33 9.95426 31.4349 6.80569 28.6991 4.586ZM18.2713 0.169553C17.5737 -0.142952 16.7542 -0.0159837 16.1827 0.488633L7.99522 7.71648H2.91176C1.30362 7.71648 0 9.0121 0 10.6093V16.395C0 17.9922 1.30362 19.2878 2.91176 19.2878H7.99765L16.1809 26.5138C16.5425 26.8311 17.0035 27 17.4706 27C17.7398 27 18.0141 26.9438 18.2689 26.829C18.9689 26.5175 19.4118 25.8298 19.4118 25.0759V1.92721C19.4118 1.16901 18.9689 0.480188 18.2713 0.169553Z"
                            fill="#43BA73"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="6.5" placeholder={undefined}>
                  <h6 className="card-label">Sound Check</h6>
                  <div className="firstStep">
                    <p className="card-label2">Checking sound...</p>
                  </div>
                  <div className="secondStep">
                    <p className="card-label2">Turn on device volume</p>
                  </div>
                  <div className="thirdStep">
                    <p className="card-label2">Device Sound On</p>
                  </div>
                </IonCol>
                <IonCol size="2" placeholder={undefined}>
                  <div className="rightIcon-setup">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807612 9.97919 0.807612 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97918 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM-1.31134e-07 13.5L20 13.5L20 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </IonCol>
              </IonRow>
            </div>
            {/* bg-grey bg-light-red bg-light-green */}
            <div
              className={
                isAngleCorrect
                  ? "cardSetup-check bg-light-green"
                  : "cardSetup-check bg-light-red"
              }
            >
              <IonRow placeholder={undefined}>
                <IonCol size="3.5" placeholder={undefined}>
                  <div className="leftIcon-setup">
                    <div className="firstStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38"
                        height="38"
                        viewBox="0 0 38 38"
                        fill="none"
                      >
                        <path
                          d="M38 19C38 22.7578 36.8857 26.4313 34.7979 29.5558C32.7102 32.6804 29.7428 35.1156 26.271 36.5537C22.7992 37.9918 18.9789 38.368 15.2933 37.6349C11.6077 36.9018 8.22219 35.0922 5.56499 32.4351C2.90779 29.7779 1.09821 26.3924 0.365087 22.7068C-0.368039 19.0211 0.00821541 15.2009 1.44627 11.7291C2.88433 8.25726 5.31959 5.28986 8.44412 3.20211C11.5686 1.11435 15.2421 1.24984e-05 18.9999 1.05086e-10L19 5.13C16.2567 5.13001 13.5751 5.94348 11.2942 7.46754C9.0133 8.9916 7.23556 11.1578 6.18578 13.6922C5.136 16.2266 4.86133 19.0154 5.39651 21.7059C5.93169 24.3964 7.25269 26.8678 9.19244 28.8076C11.1322 30.7473 13.6036 32.0683 16.2941 32.6035C18.9846 33.1387 21.7734 32.864 24.3078 31.8142C26.8422 30.7644 29.0084 28.9867 30.5325 26.7058C32.0565 24.4248 32.87 21.7432 32.87 19H38Z"
                          fill="#11A0D6"
                        />
                        <path
                          d="M19 0C22.3436 3.98722e-08 25.628 0.882354 28.5215 2.55794C31.415 4.23353 33.815 6.64302 35.4793 9.54303C37.1435 12.443 38.013 15.7309 37.9999 19.0745C37.9867 22.4181 37.0915 25.699 35.4046 28.5859C33.7177 31.4727 31.2988 33.8633 28.3923 35.5162C25.4858 37.169 22.1946 38.0256 18.8511 37.9994C15.5075 37.9732 12.2302 37.0651 9.34991 35.3669C6.46966 33.6687 4.08857 31.2405 2.44712 28.3275L6.9164 25.8091C8.11466 27.9355 9.85285 29.7081 11.9554 30.9478C14.058 32.1875 16.4505 32.8504 18.8913 32.8696C21.332 32.8887 23.7346 32.2634 25.8564 31.0568C27.9781 29.8502 29.7439 28.1051 30.9754 25.9977C32.2068 23.8903 32.8603 21.4952 32.8699 19.0544C32.8795 16.6135 32.2447 14.2134 31.0299 12.0964C29.815 9.9794 28.0629 8.22048 25.9507 6.9973C23.8385 5.77412 21.4408 5.13 19 5.13V0Z"
                          fill="#54C8F2"
                        />
                      </svg>
                    </div>
                    <div className="secondStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.0"
                        width="37.000000"
                        height="74.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <rect
                          id="backgroundrect"
                          width="100%"
                          height="100%"
                          x="0"
                          y="0"
                          fill="none"
                          stroke="none"
                        ></rect>

                        <g className="currentLayer">
                          <title>Layer 1</title>
                          <g
                            transform="translate(0,74) scale(0.10000000149011612,-0.10000000149011612) "
                            fill="#DB4B4B"
                            stroke="#ffffff"
                            id="svg_1"
                          >
                            <path
                              d="M326 690 c6 -29 6 -29 -27 -20 -79 23 -148 7 -212 -49 l-36 -32 -3 26 c-5 44 -23 27 -23 -22 l0 -48 49 0 c31 0 51 5 54 13 2 7 -5 12 -17 12 -31 0 -26 15 15 46 27 21 50 29 94 32 64 5 111 -10 72 -22 -40 -13 -25 -29 21 -22 57 9 62 17 47 70 -14 52 -43 66 -34 16z"
                              id="svg_2"
                            ></path>
                            <path
                              d="M143 512 c-20 -12 -129 -440 -116 -453 6 -6 51 -21 101 -34 70 -17 95 -20 105 -11 14 11 42 104 34 113 -3 2 -10 -18 -16 -44 -19 -74 -19 -74 -122 -48 -50 13 -93 26 -96 29 -8 7 98 414 112 432 8 11 26 9 100 -9 101 -26 105 -31 85 -103 -7 -25 -10 -47 -8 -50 9 -8 36 113 28 126 -4 6 -49 22 -101 35 -52 14 -94 25 -94 25 0 0 -6 -4 -12 -8z"
                              id="svg_3"
                            ></path>
                            <path
                              d="M240 450 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5 0 -3 -5 5 -10z"
                              id="svg_4"
                            ></path>
                            <path
                              d="M290 235 c-12 -48 -20 -88 -17 -91 2 -3 14 34 26 82 12 48 20 88 18 90 -2 3 -14 -34 -27 -81z"
                              id="svg_5"
                            ></path>
                            <path
                              d="M125 70 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0 -8 -4 5 -9z"
                              id="svg_6"
                            ></path>
                          </g>
                          <path
                            fill=""
                            fillOpacity="1"
                            stroke="#DB4B4B"
                            strokeOpacity="1"
                            strokeWidth="1"
                            strokeDasharray="none"
                            strokeLinejoin="miter"
                            strokeLinecap="butt"
                            fillRule="nonzero"
                            opacity="1"
                            d="M34.90213087552786,28.269837608563222L23.79101968031847,72.18518185629551"
                            id="svg_7"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div className="thirdStep">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="53"
                        height="53"
                        viewBox="0 0 53 53"
                        fill="none"
                      >
                        <path
                          d="M26.5 51C40.031 51 51 40.031 51 26.5C51 12.969 40.031 2 26.5 2C12.969 2 2 12.969 2 26.5C2 40.031 12.969 51 26.5 51Z"
                          fill="white"
                          stroke="#43BA73"
                          strokeWidth="3"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M34.6667 21.0557L23.7778 31.9446L18.3333 26.5001"
                          stroke="#43BA73"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="6.5" placeholder={undefined}>
                  <div className="setup-content">
                    <h6 className="card-label">Device Setup </h6>
                    <div className="firstStep">
                      <p className="card-label2">Go to setup steps</p>
                    </div>
                    <div className="secondStep">
                      <p className="card-label2">
                        Correct Phone Angle Required
                      </p>
                    </div>
                    <div className="thirdStep">
                      <p className="card-label2">Phone Setup Complete</p>
                    </div>
                  </div>
                </IonCol>
                <IonCol size="2" placeholder={undefined}>
                  <div className="rightIcon-setup">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807612 9.97919 0.807612 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97918 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM-1.31134e-07 13.5L20 13.5L20 10.5L1.31134e-07 10.5L-1.31134e-07 13.5Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </IonCol>
              </IonRow>
            </div>
          </IonGrid>
        </IonContent>
      )}
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="gait-assessment-info-page-footer-wrap">
                <div className="btn-wrap-sec">
                  {/* /gait-assessment-info */}
                  {/* <Link
                    to="/phone-audio-check"
                    className="ancher-generic-btn text-dec-none"
                  >
                    Begin Assessment Setup
                  </Link> */}

                  <IonButton
                    disabled={
                      GetOSId() !== ApplicationLookup.Desktop &&
                      (!isAngleCorrect || (!isVolumeOk && true))
                    }
                    className="generic-btn"
                    onClick={() => {
                      // history.push("/phone-audio-check");
                      // history.push("/angle-adjustment");
                      // history.push("/phone-height-requirement");
                      redirectToNextPage();
                    }}
                    placeholder={undefined}
                  >
                    Setup Complete
                  </IonButton>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default GaitAssessmentInfo;
